import { MutableRefObject } from "react";
import { Switch, TableColumnsType } from "antd";
import moment from "moment";

import { IVersion } from "@types";
import { checkPermission } from "@/utils";
import { permissions } from "@/router";
import { dateFormat } from "@/constants";
import { LoadingOutlined } from "@ant-design/icons";
import { BsTrash3 } from "react-icons/bs";
import { MdOutlineFileDownload } from "react-icons/md";

type DownloadArgs = {
  company_id: number;
  version_id: number | null;
};

export const getVersionsColumns = ({
  handleActive,
  currentId,
  company_id,
  downloadMarketData,
  downloadArgs,
  handleDelete,
  isDeleting,
  isDownloading,
  marketDataVersionId,
}: {
  handleActive: (id: number) => Promise<void>;
  currentId: null | number;

  company_id: number;

  downloadMarketData: (
    args: DownloadArgs
  ) => any;

  downloadArgs?: DownloadArgs;

  handleDelete: (id: number) => Promise<void>;

  isDeleting: boolean;
  isDownloading: boolean;

  marketDataVersionId: MutableRefObject<number | null>;
}): TableColumnsType<any> => [
    {
      title: "created at",
      dataIndex: "created_at",
      key: "created_at",
      width: 240,
      align: "center",
      render: (date: string) => (
        <div>{moment(date).format(dateFormat)}</div>
      ),
    },

    {
      title: "updated at",
      dataIndex: "updated_at",
      key: "updated_at",
      width: 240,
      align: "center",
      render: (date: string) => (
        <div>{moment(date).format(dateFormat)}</div>
      ),
    },

    ...(!checkPermission(permissions.CREATE_MARKET_DATA)
      ? []
      : ([
        {
          title: "Active",
          key: "active",
          width: 140,
          align: "center",
          render: (version: IVersion) => (
            <Switch
              onChange={checked => {
                if (!checked) return;

                handleActive(version?.id);
              }}
              checked={currentId === version?.id}
              defaultChecked={
                version?.is_active === "TRUE"
              }
            />
          ),
        },
      ] as any)),

    {
      title: "",
      key: "spacer",
    },

    {
      title: "Actions",
      key: "action",
      width: 250,
      align: "center",

      render: (version: IVersion) => {
        const isCurrentRowDownloading =
          isDownloading &&
          downloadArgs?.version_id === version?.id;

        return (
          <div className="flex items-center justify-center gap-3">
            <div
              onClick={() => {
                if (!isDownloading) {
                  downloadMarketData({
                    company_id,
                    version_id: version?.id,
                  });
                }
              }}
              className="table__action__btn table__action__btn--download"
            >
              {isCurrentRowDownloading ? (
                <LoadingOutlined className="spinner" />
              ) : (
                <>
                  <MdOutlineFileDownload className="text-white text-xl mr-1" />
                  Download
                </>
              )}
            </div>

            {checkPermission(
              permissions.DELETE_MARKET_DATA
            ) &&
              currentId !== version?.id &&
              version?.is_active !== "TRUE" && (
                <div
                  onClick={() => {
                    if (!isDeleting) {
                      handleDelete(version?.id);
                    }
                  }}
                  className="table__action__btn table__action__btn--delete"
                >
                  {isDeleting &&
                    marketDataVersionId.current ===
                    version?.id ? (
                    <LoadingOutlined className="spinner" />
                  ) : (
                    <>
                      <BsTrash3 className="text-white text-xl mr-1" />
                      Delete
                    </>
                  )}
                </div>
              )}
          </div>
        );
      },
    },
  ];